module.exports = __webpack_public_path__ + "img/stamp.0c333c2.svg";